// Styles
import './_main-404.scss';